import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../Utility';

export const initialState = {
  loading: false,
  error: null,
  data: [],
  filterData: [],
  message: null,
  page: null,
  totalRows: 0,
};

const logListStart = (state) => {
  return updateObject(state, {
    loading: true,
    error: null,
    message: null,
  });
};

const logListFail = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: action.error,
    data: [],
    filterData: [],
    message: null,
    totalRows: 0,
  });
};

const logListSuccess = (state, action) => {
  const rawData = action.data;
  const data = Array.isArray(rawData) ? rawData : rawData ? [rawData] : [];
  const combinedData = action.page === 1 ? data : [...state.data, ...data];

  return updateObject(state, {
    loading: false,
    error: null,
    data: combinedData,
    filterData: combinedData,
    message: action.message,
    page: action.page,
    totalRows: action.totalRows || data.length || 1,
  });
};

// reducer/log.js (relevant excerpt)
const logListFilter = (state, action) => {
  const { filterText, actionType } = action;
  const filterData = Array.isArray(state.filterData) ? state.filterData : [];
  let filteredItems = filterData;

  // Apply actionType filter (exact match)
  if (actionType) {
    filteredItems = filterData.filter((item) => item.actionType === actionType);
  }

  // Apply text filter (search in description)
  if (filterText) {
    const filterTextLower = filterText.toLowerCase();
    filteredItems = filteredItems.filter((item) =>
      item.description?.toLowerCase().includes(filterTextLower)
    );
  }

  return updateObject(state, { data: filteredItems });
};


export const logReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOG_LIST_REQUEST:
      return logListStart(state);
    case actionTypes.LOG_LIST_SUCCESS:
      return logListSuccess(state, action);
    case actionTypes.LOG_LIST_FAIL:
      return logListFail(state, action);
    case actionTypes.LOG_LIST_FILTER:
      return logListFilter(state, action);
    default:
      return state;
  }
};